// This file is automatically generated. Do not edit manually.

import { ControlChartCollection } from "src/api/generated/postgres/db/types/public_/tables/controlChartCollection";
import { ControlChartCollectionLineView } from "src/api/generated/postgres/db/types/public_/tables/controlChartCollectionLineView";
import { UpOrDown } from "src/api/generated/common/upOrDown";
import { ObjectPermission } from "src/api/generated/iam/model/objectPermission";
import { ObjectMemberType } from "src/api/generated/iam/model/objectMemberType";
import { AppRole } from "src/api/generated/postgres/db/types/role_management/tables/appRole";
import { AppUser } from "src/api/generated/postgres/db/types/role_management/tables/appUser";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ControlChartCollectionApi {
	export async function getPermittedCollections(): Promise<Array<ControlChartCollection>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/controlChartCollections/getPermittedCollections",
			method: "POST",
			data: {},
		});
		return response as Array<ControlChartCollection>;
	}

	export async function getDisplayData(args: {
		collectionId: number;
	}): Promise<ControlChartCollectionApi_DisplayData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/controlChartCollections/getDisplayData",
			method: "POST",
			data: {
				collectionId: args.collectionId,
			},
		});
		return response as ControlChartCollectionApi_DisplayData;
	}

	export async function getCollections(): Promise<Array<ControlChartCollection>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/controlChartCollections/getCollections",
			method: "POST",
			data: {},
		});
		return response as Array<ControlChartCollection>;
	}

	export async function saveCollection(args: { input: ControlChartCollectionApi_CollectionInput }): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/controlChartCollections/saveCollection",
			method: "POST",
			data: {
				input: args.input,
			},
		});
		return response as number;
	}

	export async function deleteCollections(args: { collectionIds: Array<number> }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/controlChartCollections/deleteCollections",
			method: "POST",
			data: {
				collectionIds: args.collectionIds,
			},
		});
		return response as void;
	}

	export async function getCollectionLines(args: {
		collectionId: number;
	}): Promise<Array<ControlChartCollectionLineView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/controlChartCollections/getCollectionLines",
			method: "POST",
			data: {
				collectionId: args.collectionId,
			},
		});
		return response as Array<ControlChartCollectionLineView>;
	}

	export async function saveCollectionLine(args: {
		input: ControlChartCollectionApi_CollectionLineInput;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/controlChartCollections/saveCollectionLine",
			method: "POST",
			data: {
				input: args.input,
			},
		});
		return response as number;
	}

	export async function deleteCollectionLines(args: { collectionLineIds: Array<number> }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/controlChartCollections/deleteCollectionLines",
			method: "POST",
			data: {
				collectionLineIds: args.collectionLineIds,
			},
		});
		return response as void;
	}

	export async function moveCollectionLine(args: {
		collectionId: number;
		collectionLineId: number;
		direction: UpOrDown;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/controlChartCollections/moveCollectionLine",
			method: "POST",
			data: {
				collectionId: args.collectionId,
				collectionLineId: args.collectionLineId,
				direction: args.direction,
			},
		});
		return response as void;
	}

	export async function createCollectionFromResourceItem(args: { resourceItemId: number }): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/controlChartCollections/createCollectionFromResourceItem",
			method: "POST",
			data: {
				resourceItemId: args.resourceItemId,
			},
		});
		return response as number;
	}

	export async function getPermissions(args: { collectionId: number }): Promise<Array<ObjectPermission>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/controlChartCollections/getPermissions",
			method: "POST",
			data: {
				collectionId: args.collectionId,
			},
		});
		return response as Array<ObjectPermission>;
	}

	export async function getPermissionFormInitData(): Promise<ControlChartCollectionApi_PermissionFormInitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/controlChartCollections/getPermissionFormInitData",
			method: "POST",
			data: {},
		});
		return response as ControlChartCollectionApi_PermissionFormInitData;
	}

	export async function savePermission(args: {
		collectionId: number;
		memberType: ObjectMemberType;
		memberId: number;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/controlChartCollections/savePermission",
			method: "POST",
			data: {
				collectionId: args.collectionId,
				memberType: args.memberType,
				memberId: args.memberId,
			},
		});
		return response as void;
	}

	export async function deletePermission(args: {
		collectionId: number;
		memberType: ObjectMemberType;
		memberId: number;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/controlChartCollections/deletePermission",
			method: "POST",
			data: {
				collectionId: args.collectionId,
				memberType: args.memberType,
				memberId: args.memberId,
			},
		});
		return response as void;
	}
}

export interface ControlChartCollectionApi_DisplayData {
	collectionId: number;
	columnsPerRow: number;
	controlChartIds: Array<number>;
	name: string;
}

export interface ControlChartCollectionApi_CollectionInput {
	collectionId: number | null | undefined;
	columnsPerRow: number;
	name: string;
}

export interface ControlChartCollectionApi_CollectionLineInput {
	collectionId: number;
	collectionLineId: number | null | undefined;
	controlChartId: number;
}

export interface ControlChartCollectionApi_PermissionFormInitData {
	roleOptions: Array<AppRole>;
	userOptions: Array<AppUser>;
}
